import ds from './DataSourceService'

const baseUrl = '/masterplans'

const getMasterplanById = masterplanId => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + masterplanId)
}

const createMasterplan = masterplan => {
  return ds.apiClientThinkHome.post(baseUrl, masterplan)
}

const updateMasterplan = masterplan => {
  return ds.apiClientThinkHome.patch(baseUrl + '/' + masterplan.id, masterplan)
}

const deleteMasterplan = masterplanId => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + masterplanId)
}

const getPoisForMasterplan = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/pois')
}

const getBuildingsForMasterplan = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/buildings')
}

const getNestedMasterplans = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id + '/masterplans')
}

const getPublishSummary = (masterplanId, buildingId) => {
  return ds.apiClientThinkHome.get(
    baseUrl + '/' + masterplanId + '/publish-summary',
    { params: buildingId ? { buildingId } : {} }
  )
}

export default {
  getMasterplanById,
  createMasterplan,
  updateMasterplan,
  deleteMasterplan,
  getPoisForMasterplan,
  getBuildingsForMasterplan,
  getNestedMasterplans,
  getPublishSummary
}
